import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Stack } from '@mui/material';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';

import { ListSection } from './ListSection';
import { TemplatesResponse, useBPFMutations } from '../../api';

interface Props {
  templates: TemplatesResponse['bpf']['templates'];
}

export const TemplatesList = ({ templates }: Props) => {
  const { push } = useHistory();
  const { handleSetActiveStatus, isActiveStatusSetting } = useBPFMutations();

  const handleRedirectToCreateTemplatePage = () => {
    push({
      pathname: '/bpf/template',
      search: '?mode=create',
    });
  };

  const handleRedirectToCopyTemplatePage = (templateId: string) => {
    push({
      pathname: `/bpf/template/${templateId}`,
      search: '?mode=copy',
    });
  };

  const handleEditTemplatePage = (templateId: string) => {
    push({
      pathname: `/bpf/template/${templateId}`,
      search: '?mode=edit',
    });
  };

  const handleRedirectToCloseReasonConfigurationPage = (templateId: string) => {
    push(`/bpf/closeReasonConfiguration/${templateId}`);
  };

  return (
    <CardContainer
      title="Deal Stages"
      actionBtn={
        <Button size="large" variant="contained" onClick={handleRedirectToCreateTemplatePage}>
          Create New template
        </Button>
      }
    >
      <Stack gap="1rem">
        {templates.map(({ templates, department }, index) => (
          <ListSection
            renderIndex={index}
            templates={templates}
            department={department}
            key={`${department.id}-${index}`}
            isActiveStatusSetting={isActiveStatusSetting}
            actions={{
              onEditTemplate: handleEditTemplatePage,
              onCopyTemplate: handleRedirectToCopyTemplatePage,
              onRedirectToCloseReasons: handleRedirectToCloseReasonConfigurationPage,
              onSetActiveStatus: templateId => handleSetActiveStatus(templateId, department.id),
            }}
          />
        ))}
      </Stack>
    </CardContainer>
  );
};
